// extracted by mini-css-extract-plugin
export default {"storyDetailListWrapper":"c-e_bw","storyDetailListWrapper__title":"c-e_bx","storyDetailListWrapper__timeline":"c-e_by","storyDetailListWrapper__list":"c-e_bz"};